(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("video-source", [], factory);
	else if(typeof exports === 'object')
		exports["video-source"] = factory();
	else
		root["video-source"] = factory();
})(self, function() {
return 